import initialState from './initialState'
const SET_MENUES = function(state, payload) {
    state.menues = payload
}

const SET_TITLE_TOP_BAR = function(state, newTitle) {
    state.titleTopBar = newTitle
    document.title = `${newTitle} - Agroplastic`
}

const RESET = function(state) {
    Object.assign(state, initialState())
}

/**
 *
 */
const SET_TOOLBAR_ITEMS = function(state, items) {
    state.items = items
}

export default {
    SET_MENUES,
    RESET,
    SET_TITLE_TOP_BAR,
    SET_TOOLBAR_ITEMS,
}
